import { render, staticRenderFns } from "./RapportsMaay.vue?vue&type=template&id=620f19e4&scoped=true"
import script from "./RapportsMaay.vue?vue&type=script&lang=js"
export * from "./RapportsMaay.vue?vue&type=script&lang=js"
import style0 from "./RapportsMaay.vue?vue&type=style&index=0&id=620f19e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f19e4",
  null
  
)

export default component.exports